import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Dropdown, MenuProps } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import MenuComponent from '../components/organisms/MenuComponent';
import { AuthProvider } from '../components/protected/ProviderAuth';
import authStore from '../stores/authStore';
import './styles.scss';

interface MainLayoutContentProps {
    setIsDarkMode: () => void;
}

const MainLayoutContent: React.FC<MainLayoutContentProps> = observer(({ setIsDarkMode }) => {
    const [collapsed, setCollapsed] = useState(false);
    const { account } = authStore;

    const items: MenuProps['items'] = [
        {
            key: '2',
            label: (
                <p onClick={() => authStore.logout()}>
                    Desconectar
                </p>
            ),
        },
    ];

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    return (
        <div className="h-screen overflow-hidden flex">
            <div className="custom-menu">
                <MenuComponent collapsed={collapsed} />
            </div>

            <div className="inline-block w-3/4 align-top" style={{ width: collapsed ? 'calc(100% - 79px)' : 'calc(100% - 256px)' }}>
                <Header className="header border-b dark:bg-midnight dark:border-0">
                    <div className="flex gap-3 items-center" >
                        <div>
                            {collapsed ? <MenuUnfoldOutlined className="dark:text-white" onClick={toggleCollapsed} /> : <MenuFoldOutlined className="dark:text-white" onClick={toggleCollapsed} />}
                        </div>
                        <a target="_blank" rel="noopener noreferrer" href="https://stoom.com.br/"><h2 className="dark:text-white">Visitar Loja</h2></a>

                        {/* {unsavedChanges &&
                            <div className="bg-white p-1 rounded-full flex gap-2 items-center px-2">
                                <div className="min-w-2 min-h-2 rounded-full bg-yellow-500 max-h-2"></div>
                                <p className="text-xs ">Alterações não salvas</p>
                            </div>
                        } */}
                    </div>

                    <div className="flex gap-6 flex-row">
                        {/* <MoonOutlined className="dark:text-white" onClick={() => setIsDarkMode()} /> */}
                        {/* <BellOutlined className="dark:text-white" /> */}

                        <Dropdown className="flex items-center cursor-pointer" menu={{ items }} placement="bottomRight" arrow>
                            <div className="flex gap-2" onClick={(e) => e.preventDefault()}>
                                <img className='text-2xl' src="/assets/header-user.png" alt="user" />
                                <p className="dark:text-white">{account?.name}</p>
                            </div>
                        </Dropdown>
                    </div>
                </Header>

                <div className="box dark:bg-midnight">
                    <Outlet />
                </div>

                {/* <UnsavedChangesModal hasUnsavedChanges={unsavedChanges} /> */}
            </div>
        </div>
    );
});

interface MainLayoutProps {
    setIsDarkMode: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ setIsDarkMode }) => {
    return (
        <AuthProvider>
            <MainLayoutContent setIsDarkMode={setIsDarkMode} />
        </AuthProvider>
    );
};

export default MainLayout;